import { ConnectionMode } from './../../../base/models/models.swagger.generated';
/* eslint-disable @typescript-eslint/member-ordering */
import { AbstractControl, AsyncValidatorFn, FormBuilder, Validators } from '@angular/forms';
import { AvpCustomAdaptor } from '../../../base/shared/syncfusion/avp-custom-adaptor';
import { DataManager } from '@syncfusion/ej2-data';
import { userManagementRoute } from '../../../core/routing/route-names';
import { Router } from '@angular/router';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ClientAdministrationService } from './client-administration.service';
import { Component, HostListener, OnInit } from '@angular/core';
import { CommandClickEventArgs, CommandModel, GridModule } from '@syncfusion/ej2-angular-grids';
import { GridConstantsFactory } from 'src/app/base/shared/syncfusion/grid-constants-factory';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';
import { ClientDTO, FilterDTO, FilterOperator, SortDirection } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { timer } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { SfCommandButtonType } from 'src/app/base/models/syncfusion-data';
import { ClientAdministraionEditFormComponent } from './client-administraion-edit-form/client-administraion-edit-form.component';

import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { SearchFieldComponent } from '../../../base/shared/search-field/search-field.component';
import { TitleBarComponent } from '../../../base/shared/title-bar/title-bar.component';
import { ClientAdministrationEditFormType } from './client-administraion-edit-form/client-administraion-edit-form.type';

@Component({
    selector: 'app-client-administration',
    templateUrl: './client-administration.component.html',
    styleUrls: ['./client-administration.component.scss'],
    imports: [TitleBarComponent, SearchFieldComponent, CheckBoxModule, GridModule, ToolbarModule, ClientAdministraionEditFormComponent, TranslateModule]
})
export class ClientAdministrationComponent extends GridBaseComponent implements OnInit {
  private addUserCommand = {
    type: 'None',
    title: this.translateService.instant('i18n.domain.client-administration.overview.tooltips.add-users'),
    buttonOption:
    {
      cssClass: 'icon-btn',
      iconCss: 'icon-user--multiple e-icons'
    }
  } as CommandModel;

  private defaultRetentionPeriodInDays = 180;

  constructor(private clientAdministrationService: ClientAdministrationService,
              private router: Router,
              private fb: FormBuilder,
              translateService: TranslateService,
              private spinnerService: SpinnerService) {
    super(null, translateService, clientAdministrationService);
    this.gridCommands = [...GridConstantsFactory.createStandardGridCommands(), this.addUserCommand];
    this.searchOptions = {fields: ['name', 'address', 'zip', 'city', 'email', 'phoneNumber']};
  }

  @HostListener('window:beforeunload')
  beforeUnload() {
    return !this.gridEditForm?.dirty;
  }

  public ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.clientAdministrationService, this.spinnerService),
    });
    this.isActiveColumnName = 'isActive';
    this.editDialogTitle = 'i18n.domain.client-administration.overview.edit-dialog-title';
    this.addDialogTitle = 'i18n.domain.client-administration.overview.tooltips.add';
    // a fix to make sure that translated tooltip is loaded properly
    setTimeout(() => {
      this.translateService.get('i18n.domain.client-administration.overview.tooltips.add-users').subscribe((value: string) => {
        this.addUserCommand.title = value;
      });
    }, 200);
    this.translateService.onLangChange.subscribe(_ => {
      this.addUserCommand.title = this.translateService.instant('i18n.domain.client-administration.overview.tooltips.add-users');
    });
  }

  public commandClick(args: CommandClickEventArgs) {
    if (args.commandColumn?.type === SfCommandButtonType.None) {
      const clientId = ((args.rowData) as any).id;
      this.router.navigate([userManagementRoute], {queryParams: { clientId }});
    }
  }

  protected override addObjectCompare(addedObject: ClientDTO, rowObject: ClientDTO): boolean {
    if (this.addIndexFindColumnName) {
      return addedObject.name === rowObject.name && addedObject.address === rowObject.address && addedObject.zip === rowObject.zip;
    }
    return false;
  }

  protected override getDataToSave(): any {
    const formValue =  this.gridEditForm.value;
    formValue.clientIdent = formValue.clientIdent.trim();

    return {
      ...formValue,
      automaticParkingScheduleToleranceInMinutes: formValue.automaticParkingScheduleToleranceInMinutes ?? 0
    };
  }

  protected initializeEditForm(data: ClientDTO): void {
    this.gridEditForm = this.fb.group<ClientAdministrationEditFormType>({
      id: this.fb.control(data.id),
      name: this.fb.control(data.name ?? null, [Validators.required]),
      address: this.fb.control(data.address ?? null),
      zip: this.fb.control(data.zip ?? null, [CustomValidatorsFactory.createZipValidator()]),
      city: this.fb.control(data.city ?? null),
      email: this.fb.control(data.email ?? null, [Validators.email]),
      phoneNumber: this.fb.control(data.phoneNumber ?? null, [CustomValidatorsFactory.createPhoneValidator()]),
      dataRetentionPeriodInDays: this.fb.control(data.dataRetentionPeriodInDays ?? this.defaultRetentionPeriodInDays, [Validators.required, Validators.min(0)]),
      clientIdent: this.fb.control(data.clientIdent ?? null, [Validators.required, Validators.maxLength(20)],  [this.clientIdentValidator()]),
      automaticParkingSchedulesEnabled: this.fb.control(data.automaticParkingSchedulesEnabled ?? false, [Validators.required]),
      automaticParkingScheduleToleranceInMinutes : this.fb.control(data.automaticParkingScheduleToleranceInMinutes, [Validators.min(0)]),
      isActive: this.fb.control(data.isActive),
      connectionMode: this.fb.control(data.connectionMode ?? ConnectionMode.RequestConnection),
      qrCodeIdentificationEnabled: this.fb.control(data.qrCodeIdentificationEnabled ?? false),
      auditLogEnabled: this.fb.control(data.auditLogEnabled ?? false),
      enableLPRPictureStorage: this.fb.control(data.enableLPRPictureStorage ?? false),
      enableLPRPictureStorageOnOffense: this.fb.control(data.enableLPRPictureStorageOnOffense ?? false),
      custom1Name: this.fb.control(data.custom1Name ?? null),
      custom2Name: this.fb.control(data.custom2Name ?? null),
      custom3Name: this.fb.control(data.custom3Name ?? null),
      custom4Name: this.fb.control(data.custom4Name ?? null),
      custom5Name: this.fb.control(data.custom5Name ?? null),
      custom6Name: this.fb.control(data.custom6Name ?? null),
      custom7Name: this.fb.control(data.custom7Name ?? null),
      custom8Name: this.fb.control(data.custom8Name ?? null),
      custom9Name: this.fb.control(data.custom9Name ?? null)
    });
  }

  protected getEditDialogTitleParams(rowData): any {
    return {param: rowData.name};
  }

  private clientIdentValidator(): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const clientIdentFilter = new FilterDTO({isComplex: false, field: 'clientIdent', operator: FilterOperator.Equal, value: control.value.trim()});
      return timer(500)
        .pipe(
          switchMap(() => this.clientAdministrationService.getData(0, 0, [clientIdentFilter], 'id', SortDirection.Ascending)),
          map(res => {
            const isIdentInUse = res.totalNumberOfItems > 0;
            const sameAsOriginal = res.items.find(client => client.id === this.gridEditForm.get('id').value)?.clientIdent === control.value;

            return sameAsOriginal || !isIdentInUse ? null : {identAlreadyInUse: true};
          })
        );
    };
  }
}
